import AppShell from './AppShell';

customElements.define('app-shell', AppShell);
